export default __webpack_public_path__ + "static/media/Veeva_logo.5e8a133c.svg";